module.exports = "<div style=\"text-align: center\">\n  <mat-spinner></mat-spinner>\n</div>\n"